export const MEDIA = {
  heroBackground:
    "https://images.unsplash.com/photo-1588373731788-510100bfd700?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  founder:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_wealth-visual-ai/artifacts/sby232qr_Raj1.jpeg",
  exterior1:
    "https://images.unsplash.com/photo-1782392494100-d12f658a3fb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBkYXJrJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzgyNzY5NDM0fDA&ixlib=rb-4.1.0&q=85",
  exterior2:
    "https://images.unsplash.com/photo-1776186243408-3c0489503faa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBkYXJrJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzgyNzY5NDM0fDA&ixlib=rb-4.1.0&q=85",
};

export const PROJECTS = [
  {
    id: "saadiyat",
    name: "Saadiyat",
    type: "Business",
    status: "Ongoing Sales",
    location:
      "Tashkent, Mirzo-Ulugbek District, intersection of Katta Darkhan and Akkurgan Streets.",
    completion: "4th Quarter 2027 (Phase 1)",
    image:
      "https://images.unsplash.com/photo-1541447271487-09612b3f49f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBza3lzY3JhcGVyJTIwYnVpbGRpbmclMjBldmVuaW5nfGVufDB8fHx8MTc4Mjc2OTQzNHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "c1",
    name: "C1",
    type: "Premium",
    status: "Ongoing Sales",
    location: "46A S. Azimov Street, Yashnabad District, Tashkent.",
    completion: "1st Quarter 2028",
    image:
      "https://images.unsplash.com/photo-1624204386084-dd8c05e32226?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBza3lzY3JhcGVyJTIwYnVpbGRpbmclMjBldmVuaW5nfGVufDB8fHx8MTc4Mjc2OTQzNHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "regnum-plaza",
    name: "Regnum Plaza",
    type: "Business",
    status: "Ongoing Sales",
    location: "Sayram Street, Mirzo-Ulugbek District, Tashkent.",
    completion: "1st Quarter 2025 (Phase 1)",
    image:
      "https://images.unsplash.com/photo-1526546334624-2afe5b01088d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBza3lzY3JhcGVyJTIwYnVpbGRpbmclMjBldmVuaW5nfGVufDB8fHx8MTc4Mjc2OTQzNHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "soy-boyi",
    name: "Soy Bo'yi",
    type: "Business",
    status: "Ongoing Sales",
    location: "3A Yusuf Sakkaki Avenue, Uchtepa District, Tashkent.",
    completion: "1st Quarter 2026 (Phase 1)",
    image:
      "https://images.unsplash.com/photo-1674857567490-290dd93aaa62?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBza3lzY3JhcGVyJTIwYnVpbGRpbmclMjBldmVuaW5nfGVufDB8fHx8MTc4Mjc2OTQzNHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "nest-one",
    name: "Nest One",
    type: "Premium",
    status: "Last Remaining Apartments",
    location: "Tashkent, Shaykhantahur District, 1A/1 Islam Karimov Street.",
    completion: "Commissioned",
    image:
      "https://images.pexels.com/photos/4885978/pexels-photo-4885978.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const SISTER_COMPANIES = [
  { name: "VRD Metal Framing", url: "https://vrdmetalframing.com", sector: "Steel Framing" },
  { name: "Deep Cryogenic", url: "https://deepcryogenic.com", sector: "Cryogenics" },
  { name: "Bonolit", url: "https://bonolit.us", sector: "Building Materials" },
  { name: "Integrative Build System", url: "https://integrativebuildsystem.com", sector: "Construction" },
  { name: "Goyal Decoster", url: "https://www.goyaldecoster.com", sector: "Exterior Solutions" },
  { name: "EcoAquaClean", url: "https://ecoaquaclean.com", sector: "Water Tech" },
  { name: "Bright Builder Construction", url: "https://brightbuilderconstruction.com", sector: "Construction" },
  { name: "Bio Oil US", url: "https://biooilus.com", sector: "Bio Energy" },
  { name: "Red Rock Investment Equity", url: "https://redrockinvestmentequity.com", sector: "Investment" },
];

export const STATS = [
  { value: 30, suffix: "+", label: "Years of Experience" },
  { value: 9, suffix: "", label: "Group Companies" },
  { value: 5, suffix: "", label: "Flagship Developments" },
  { value: 6, suffix: "", label: "Industry Verticals" },
];

export const CONTACT = {
  tagline: "Drop us a line, if you are interested in partnership for Florida, USA!",
  address: "7512 Dr. Phillips Blvd, Ste 50-353 Orlando, FL 32819, US",
  phone: "+1 (407) 535-2877",
  phoneRaw: "+14075352877",
  email: "Info@titaniumwealthusa.com",
};
